import store from '@/store';

export default class ListingOverviewComponent {
	public get campaignEditorUrl(): string {
		return `${this.uniAdminUrl}/campaign-editor/#/general/${this.campaignId}/`;
	}

	private get campaignId(): number {
		return store.getters.campaignId();
	}

	private get uniAdminUrl(): string {
		return store.getters.uniAdminUrl();
	}
}
